// extracted by mini-css-extract-plugin
export default {"wrapper":"VerificationApproachOrganism_wrapper__7Nw0t"};